<script>
export default {

	functional: true,

	render(h, context) {
		const MAX_LENGTH = 75;

		let value = context.props.row[ context.props.field.slug ];
		if (value === null) {
			value = '';
		}
		return context._v(value || 'N/A');
	}
};
</script>
